export default {
      id: "eye-closed-usage",
      viewBox: "0 0 39 24",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#eye-closed",
      toString: function () {
        return this.url;
      }
    }